import React, { useState } from "react";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageContainer from "../components/pages/PageContainer";
import GameSearchBar from "../components/Sidebar/GameSearchBar";
import Menu from "./Game/Menu";
import { Outlet, useOutletContext, useLocation } from "react-router";

const Contest = () => {
  const [sidebarToggle] = useOutletContext();
  const [search, setSearch] = useState("");
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const location = useLocation();

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  let headingText = "Leagues"; // Default heading
  if (location.pathname === "/contest/add-league") {
    headingText = "Create League";
  } else if (location.pathname === "/contest/my-games") {
    headingText = "My Leagues";
  }
  else if(location.pathname === "/contest/cash-leagues"){
    headingText= "Cash Leagues";
  }
  else if (/\/[^/]+\/edit$/.test(location.pathname)) {
  // Check if the path matches ":slug/edit"
  headingText = "Edit League";
}

  // Check if the current path matches "/contest/game-detail/[number]"
  // const isGameDetailPage = /^\/contest\/game-detail\/\d+$/.test(location.pathname);

  const isGameDetailPage = /^\/contest\/(game-detail\/\d+|[^/]+(?<!my-games|add-league|cash-leagues))$/.test(location.pathname);



  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />

      {/* Conditionally render heading for all paths except game-detail pages */}
      {!isGameDetailPage && (
        <div className="md:ml-60 bg-white mt-24">
          <h1 className="px-8 py-2 bg-[#F1F5F9] inter font-semibold text-xl hidden md:block mb-5">
            {headingText}
          </h1>
        </div>
      )}

      <PageContainer>
        {/* Conditionally render GameSearchBar */}
        {!isGameDetailPage && location.pathname !== "/contest/add-league" && !/\/[^/]+\/edit$/.test(location.pathname) &&(
          <GameSearchBar
            search={search}
            handleChange={handleChange}
            handleSubmit={(e) => e.preventDefault()} // Prevent form submission
            isMobileView={isMobileView}
            clearSearch={() => setSearch("")}
          />
        )}

        {/* Conditionally render Menu */}
        {!isGameDetailPage && location.pathname !== "/contest/add-league" && !/\/[^/]+\/edit$/.test(location.pathname) && <Menu />}

        {/* Pass search and handleChange to child components via Outlet context */}
        <Outlet context={{ search, handleChange }} />
      </PageContainer>
    </>
  );
};

export default Contest;
